"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.tabs.threads': '线程',
    'whatsapp.tabs.settings': '设置',
    'whatsapp.tabs.groups': '群组',
    'whatsapp.tabs.directMessages': '私信',
    'whatsapp.tabs.email': '电子邮件',
    'whatsapp.tabs.emailSettings': '邮件设置',
};
